(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dial-card-single-v2"] && !Shopify.designMode) return;
  try {
    var singleDialEase =
    window.singleDialEase ||
    function (t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    };
  window.singleDialEase = singleDialEase;

  function animateSingleDial(dial, duration = 2000) {
    const target = Number(dial.dataset.target) || 0;
    const color = dial.dataset.color || '#19ec06';
    const numberEl = dial.querySelector('.dial-card-single__number');

    dial.style.setProperty('--dial-accent', color);

    const start = performance.now();

    function frame(now) {
      const progress = Math.min((now - start) / duration, 1);
      const eased = singleDialEase(progress);
      const current = eased * target;

      dial.style.setProperty('--dial-value', current);
      numberEl.textContent = Math.round(current);

      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        dial.style.setProperty('--dial-value', target);
        numberEl.textContent = target;
      }
    }

    requestAnimationFrame(frame);
  }

  function initDialCardSingle(root) {
    if (!root || root.dataset.dialAnimated === 'true') return;
    const dials = root.querySelectorAll('.dial-card-single__dial');
    const baseDuration = Number(root.dataset.dialDuration) || 2000;
    const speedMultiplierRaw = Number(root.dataset.dialSpeed);
    const speedMultiplier =
      Number.isFinite(speedMultiplierRaw) && speedMultiplierRaw > 0 ? speedMultiplierRaw : 1;
    const duration = Math.max(50, baseDuration / speedMultiplier);

    dials.forEach((dial, idx) => {
      const delay = idx * 120;
      setTimeout(() => animateSingleDial(dial, duration), delay);
    });

    root.dataset.dialAnimated = 'true';
  }

  // Defer dial animation until the block enters the viewport to keep initial load lean.
  function setupDialCardObserver(scope = document) {
    const cards = scope.querySelectorAll('[data-dial-card-single]');
    if (!cards.length) return;

    const animatedCards = (window.dialCardSingleAnimatedSet ||= new WeakSet());

    if (!('IntersectionObserver' in window)) {
      cards.forEach((card) => initDialCardSingle(card));
      return;
    }

    if (!window.dialCardSingleObserver) {
      window.dialCardSingleObserver = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !animatedCards.has(entry.target)) {
              animatedCards.add(entry.target);
              initDialCardSingle(entry.target);
              obs.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.4, rootMargin: '0px 0px -10% 0px' },
      );
    }

    cards.forEach((card) => window.dialCardSingleObserver.observe(card));
  }

  if (!window.dialCardSingleEventsBound) {
    const bootDialCards = () => setupDialCardObserver();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootDialCards, { once: true });
    } else {
      bootDialCards();
    }

    document.addEventListener('shopify:section:load', (event) => {
      setupDialCardObserver(event.target);
    });

    window.dialCardSingleEventsBound = true;
  }
  } catch(e) { console.error(e); }
})();

})();
